import { useCallback, useState } from 'react'
import { useMounted } from '../../../Hooks/useMounted'
import { useAppDispatch } from '../../../Hooks/useAppDispatch'
import { LabsActions } from '../StoreAdapter'
import { LabSchema } from '../../../Schema/LabSchema'
import { ServiceLocator } from '../../../Services/ServiceLocator'
import { LabsAPI } from '../../../Services/API/LabsAPI'

export const useDeleteLab = () => {
  const dispatch = useAppDispatch()
  const mounted = useMounted()

  const [processing, setProcessing] = useState(false)
  const [error, setError] = useState(false)
  const [errorMessage, setErrorMessage] = useState<string>(null)

  const deleteLab = useCallback(
    async (schemaId: string): Promise<LabSchema> => {
      setProcessing(true)
      return ServiceLocator.resolve(LabsAPI)
        .deleteEntity(schemaId)
        .then((schema) => {
          dispatch(LabsActions.removeOne(schemaId))
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(null)
          }
          return schema
        })
        .catch((err) => {
          if (mounted.current) {
            setProcessing(false)
            setError(true)
            setErrorMessage(err?.response?.data?.errorMessage)
            throw err
          }
          return null
        })
    },
    [dispatch, mounted],
  )

  return {
    processing,
    error,
    errorMessage,
    deleteLab,
  }
}
